import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';
import { TypeDecoratedSubscriptionRecord } from '@/lib/api/subscriptionManager/decorators';
import { TypePlayKitPageTranslations } from '@/utils/translations/types/TypePlayKitPageTranslations';
import React from 'react';
import { UpsellCard } from '../UpsellCard';
import { trackClickEvent } from '../../utils';
import { CTA_NAMES } from '@/utils/rudderstack';
import useLocale from '@/hooks/useLocale';
import {
  buildQueryString,
  constructLegacyCustomerPortalLink,
} from '@/utils/shopSubdomain';
import { PROCESS_STATUS } from '@/lib/api/subscriptionManager/types';

export type LayoutAgedOutSubscriptionProps = {
  t: TypePlayKitPageTranslations;
  selectedSubscription: TypeDecoratedSubscriptionRecord;
};

function LayoutAgedOutSubscription({
  t,
  selectedSubscription,
}: LayoutAgedOutSubscriptionProps) {
  const showUpsell = selectedSubscription.partial_subscription;
  const locale = useLocale();

  const lastShippedKitAnchor = selectedSubscription.scheduled_items.findLast(
    (item) => item.process_status === PROCESS_STATUS.COMPLETED,
  )?.product?.anchor;
  const queryString =
    lastShippedKitAnchor &&
    buildQueryString([
      {
        key: 'anchor',
        value: lastShippedKitAnchor,
      },
    ]);

  const giftExtensionLink = constructLegacyCustomerPortalLink(
    locale,
    [
      selectedSubscription.recipient_uuid,
      'subscriptions',
      selectedSubscription.uuid,
      'gift-extension',
    ],
    queryString,
  );

  const SubText = () => {
    return (
      <>
        <p className="mb-5">{t.giftUpsellSubtext}</p>
        <p>{t.giftUpsellCredits}</p>
      </>
    );
  };

  return (
    <div data-testid="layout-aged-out-subscription" className="text-center">
      <HeaderText
        classes="text-3xl md:text-4xl pb-2"
        size={HeaderSize.H2}
        align="left"
        text={t.subscriptionComplete}
      />
      {showUpsell ? (
        <UpsellCard
          headerText={t.giftUpsellHeader}
          subText={<SubText />}
          ctaText={t.giftUpsellCta}
          ctaLink={giftExtensionLink}
          onClick={() => {
            trackClickEvent(CTA_NAMES.GIFT_EXTENSION_FLOW_STARTED);
          }}
        />
      ) : (
        <p className="pb-4 md:pb-6 text-base md:text-lg text-left">
          {t.agedOutSubtext}
        </p>
      )}
    </div>
  );
}

export default LayoutAgedOutSubscription;
